<div class="modal-header">
    Firma
</div>
<div class="modal-body">
    <signature-pad #sigPad [options]="signaturePadOptions"></signature-pad>
    <button (click)="sigPad.clear()">Cancella</button>
</div>
<div class="modal-footer">

    <button class="btn btn-block btn-outline-success" (click)="confirmSignature(sigPad)">OK</button>
    <button class="btn btn-block btn-outline-secondary" (click)="close()">Annulla</button>

</div>    